import { ContainerModule, interfaces } from 'inversify';
import { AdminService, IAdminService } from './admin.service';
import { AdminStore, IAdminStore } from './admin.store';
import { AdminApiService, IAdminApiService } from './services/adminApi.service';

export const adminModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IAdminStore.$).to(AdminStore).inSingletonScope();
  bind(IAdminService.$).to(AdminService).inSingletonScope();
  bind(IAdminApiService.$).to(AdminApiService).inSingletonScope();
});
